<template>
    <div id="update-discount" class="py-3 px-3">
        <v-btn
            @click="onShowDiscountUpdateLogs"
        >
        <v-icon
        class="mr-2"
        color="primary"
        flat>history</v-icon>
            Show Discount Update Logs
        </v-btn>
        <!-- <p class="font-weight-bold headline">Update Discount Qualification for {{ newWorkload.oppproject.OppReg_Id }}</p> -->
        <div class="pricing-tier-overview-container">
            <div class="my-2 px-2 py-1 black">
                <label class="font-weight-bold white--text">Pricing Tiers Overview [<a href="#" @click="downloadGuide" >Download Oppreg Guide for more details</a>] </label>
            </div>
            <div class="px-2 py-2">
                <p>DXC’s approved discounts for AWS Services are indexed to AWS Public/Published Pricing</p>
                <ul>
                    <li><a href="#" @click="downloadGuide" ><u>Download Oppreg Guide</u></a> for discount details. Note the public sector SPP qualifications in the OppReg guide.</li>
                    <li>Solution Provider Program (SPP) – up to 12% discount (with new account ID) for the first 2 years and 7% thereafter. </li>
                    <li>Private Pricing Agreement (PPA) – 21% discount for qualified workloads.</li>
                    <li>View the OppReg guide download for pricing tier details. </li>
                </ul>
            </div>
        </div>
        <v-layout
            row
            wrap
        >
            <v-flex md12>
            <div class="my-2 px-2 py-1 black">
                <label class="font-weight-bold white--text">Pricing Qualification Version 2.0</label>
            </div>
            <div class="my-2">
                <label class="font-weight-bold red--text">Select the ONE statement that applies to the AWS workload *</label>
            </div>

            <v-layout
                column
                >
                <v-radio-group
                    light
                    class="pricing-tier-qualification px-3"
                    v-model="newWorkload.oppproject.Pricing_Tier_Qualification_2"
                    :disabled="!isRecordView"
                    @change="determineWorkloadType">
                    <v-radio
                        class="my-2 pricing-tier-radio"
                        value="1"
                        color="orange"
                    >
                        <span slot="label" class="ml-2 black--text">1. The solution is based primarily on DXC IP whereby the customer will not have access to the associated AWS services, infrastructure or operating systems managed by DXC.</span>
                    </v-radio>
                    <div v-if="newWorkload.oppproject.Pricing_Tier_Qualification_2 === '1'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                        <label class="font-weight-bold black--text title">1. Based on your selection of #1, this workload qualifies for the PPA discount</label>
                    </div>
                    <v-radio
                        class="my-2 pricing-tier-radio"
                        value="2"
                        color="orange"
                    >
                        <span slot="label" class="ml-2 black--text">2. The customer requires direct access to the AWS Console, workloads, services, or logs. </span>
                    </v-radio>
                    <div v-if="newWorkload.oppproject.Pricing_Tier_Qualification_2 === '2'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                        <label class="font-weight-bold black--text title">2. Based on your selection of #2, this workload qualifies for the SPP discount</label>
                    </div>
                </v-radio-group>
            </v-layout>
            <div class="my-2 px-2 py-1 black">
                <label class="font-weight-bold white--text">Attestation</label>
            </div>
            <v-layout row style="gap: 1rem">
                <v-flex md6>
                    <v-menu
                        v-model="attestedDateMenu" 
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        full-width
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :disabled="!isRecordView"
                            v-model="attestedDate"
                            label="Attested Date *"
                            v-on="on"
                            readonly
                        />
                        </template>
                        <v-date-picker
                        :disabled="!isRecordView"
                        v-model="attestedDate"
                        attach
                        no-title
                        scrollable
                        @input="attestedDateMenu = false"/>
                    </v-menu>
                </v-flex>
                <v-flex md6>
                    <v-text-field
                        :disabled="!isRecordView"
                        v-model="newWorkload.oppproject.Attested_By_Email_2"
                        label="Email *"
                    />
                </v-flex>
            </v-layout>
            <v-layout style="gap: 1rem">
                <v-flex md6>
                <v-text-field
                    v-validate="{ required: true }"
                    v-model.lazy="newWorkload.oppproject.Attested_By_Title_2"
                    :error-messages="errors.collect('attestedByTitle')"
                    :disabled="!isRecordView"
                    data-vv-name="attestedByTitle"
                    data-vv-validate-on="blur"
                    label="Job Title *"
                />
                </v-flex>
                <v-flex md6>
                <v-text-field
                    v-validate="{ required: true }"
                    v-model.lazy="newWorkload.oppproject.Attested_By_Manager_2"
                    :error-messages="errors.collect('attestedByManager')"
                    :disabled="!isRecordView"
                    data-vv-name="attestedByManager"
                    data-vv-validate-on="blur"
                    label="Manager *"
                />
                </v-flex>
            </v-layout>
            <div>
                <p>Attestation and the response content is required for contractual compliancy. This attestation is subject to audit. Inaccurate responses could change the pricing tier. If you are unsure of responses throughout this application for registration, please defer to your manager to assist. </p>
            </div>
            
            <div v-if="newWorkload.oppproject.Pricing_Tier_Qualification === '2'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                <p class="font-weight-bold black--text title">Reminder, Please download the Oppreg Guide. SPP has dependencies in order to realise the full SPP discount.</p>
            </div>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { checkActionPermission } from '@/utils/helper'

export default {
    data() {
        return {
            attestedDateMenu: false
        }
    },
    computed: {
        ...mapState('admin/oppregAdmin', ['newWorkload']),
        attestedDate: {
            get () {
                return window.moment(this.newWorkload.oppproject.Attested_By_Date_2).isValid()
                ? this.newWorkload.oppproject.Attested_By_Date_2
                : null
            },
            set (date) {
                this.newWorkload.oppproject.Attested_By_Date_2 = date
            }
        },
        isRecordView() {
            return checkActionPermission('write', 'oppreg-admin')
        }
    },
    methods: {
        ...mapMutations({
            setWorkloadType: 'admin/oppregAdmin/setWorkloadType'
        }),
        determineWorkloadType () {
            let workloadType
            switch (this.newWorkload.oppproject.Pricing_Tier_Qualification_2) {
                case '1':
                    workloadType = 'PPA'
                    break;
                case '2':
                    workloadType = 'SPP'
                    break;
                case '3':
                    workloadType = 'DONTKNOW'
                    break;
                default:
                    break;
            }
            this.setWorkloadType(workloadType)
        },
        downloadGuide () {
            window.open(window.location.origin + '/DXC+AWS+Opportunity+Registration+Guide.pdf', '_blank').focus();
        },
        onShowDiscountUpdateLogs() {
            this.$store.commit('setChangeLog', { action: 'DiscountUpdate' })
            this.$store.dispatch('showLogRecords', this.$route.params.id)
        }
    },
}
</script>
<style lang="scss" scoped>

.pricing-tier-radio /deep/ label {
    color: rgba(0,0,0,.87) !important;
}

#update-discount {
    .pricing-tier-overview-container > div > p {
      border-bottom: 1px solid #000;
      font-size: 16px !important;
      color: #000;
    }

    .pricing-tier-qualification {
        font-weight: bold;
        .pricing-tier-radio {
            input {
                margin: 30px;
            }
        }
    }
}

    
</style>